import {
  AvatarGroup,
  Stack,
  Tooltip,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Avatar from "../../../../../../components/Avatar";
import { Avatar as Image } from "@mui/material";
import UsersIcon from "../../../../../../styles/svg/users-icon.svg";
import LastSeenUser from "./LastSeenDropdown";
import {
  hasImage,
  getInitials,
} from "../../../../../../utils";
import { TooltipName } from "../../../../../../utils/Enums";
import CustomMenu from "../../../../../../components/Menu";

function CardLastSeenDetail({ cardDetail }) {
  const [users, setUsers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [visitedUser, setVisited] = useState([]);
  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);

  const isLessUsers = useMemo(() => 
    users?.length < 6 && users?.length >= 1,
    [users?.length]
  );

  const sortedUsers = useMemo(() => {
    if (!cardDetail?.read_receipt) return [];
    return cardDetail.read_receipt.sort(
      (a, b) => new Date(b.last_seen) - new Date(a.last_seen)
    );
  }, [cardDetail?.read_receipt]);

  const sortedVisitedUsers = useMemo(() => {
    if (!cardDetail?.read_receipt) return [];
    return cardDetail.read_receipt
      .filter((item) => item.last_seen != null)
      .sort((a, b) => new Date(b.last_seen) - new Date(a.last_seen));
  }, [cardDetail?.read_receipt]);

  useEffect(() => {
    if (cardDetail) {
      setVisited(sortedVisitedUsers);
      setUsers(sortedUsers);
    }
  }, [cardDetail, sortedVisitedUsers, sortedUsers]);

  const closeUserList = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleAvatarClick = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  return (
    <div className="sidebar-heading-content">
      <Stack spacing={2} direction="row" className="align-items-center">
        <div className="d-flex justify-content-center align-items-center">
          <p className="mr-8 last-seen-text">
            Last seen:
          </p>
          <Tooltip title={TooltipName.BOARD_PAGE.USER_LIST}>
          <AvatarGroup
            total={users?.length}
            renderSurplus={(surplus) => (
              <span onClick={(event) => setAnchorEl(event.currentTarget)}>
                {/* +{users?.length - 4} */}
                {users?.length > 4
                  ? visitedUser?.length > 3
                    ? `+${users?.length - 4}`
                    : `+${users?.length - visitedUser?.length}`
                  : `+${users?.length - visitedUser?.length}`}
              </span>
            )}
            className={`avatar-group cursor-pointer ${"avatar-group-border"}`}
          >
            {visitedUser?.map((el) => (
              <Avatar
                key={`user-avtar-${el.user_id}`}
                username={`${el?.user?.first_name} ${el?.user?.last_name}`}
                user_image={el.user.user_image}
                title={`${el?.user?.first_name} ${el?.user?.last_name}`}
                style={
                  !hasImage(el.user_image)
                    ? {
                        bgColor: el?.profile_color?.background,
                        color: el?.profile_color?.text,
                      }
                    : {
                        color: "white",
                        bgColor: "#fff !important",
                      }
                }
              >
                {getInitials(el.user.first_name, el.user.last_name)}
              </Avatar>
            ))}
          </AvatarGroup>
          </Tooltip>
          {isLessUsers && (
            <Tooltip title={"User List"}>
              <Image
                onClick={handleAvatarClick}
                src={UsersIcon}
                className={"header-avatar cursor-pointer"}
              >
                AS
              </Image>
            </Tooltip>
          )}

          <CustomMenu
            id="user-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={closeUserList}
            className="assign-board-owner-list"
          >
            {users.map((el,index) => {
              return <LastSeenUser   key={`last-seen-user-list-${index}`} user={el} />;
            })}
          </CustomMenu>
        </div>
      </Stack>
      </div>
  );
}

export default React.memo(CardLastSeenDetail);
